import React, { useEffect, useState } from 'react';

import Chart from "react-apexcharts";

function DonutHubspotCard({
  data,
  height
}) {

  const [ options, setOptions ] = useState({})

  useEffect(() => {
    if(data!=null && data!={} && 'labels' in data) {
      setOptions({
        labels: data.labels,
        chart: {
          type: 'donut',
        },
        legend: {
          position: "right"
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 180
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      })
    }
  }, [data]);

  return (
      <div className="flex-grow bg-white shadow-1 rounded-sm border
      border-gray-200 p-3 divide-y divide-slate-200 m-auto my-5 overflow-y-hidden max-h-625">
        {options != {} && 'series' in data && data.series.length>0 ?
            <Chart
              options={options}
              type="donut"
              height={height}
              series={data.series}/> : ''}
      </div>
  );
}

export default DonutHubspotCard;
